import React from 'react'
import LibMarkdown from 'react-native-markdown-display'

const Markdown = (props) => <LibMarkdown {...props} style={[{ body: {marginTop: 100, marginBottom: 0} }, props.style]}/>
export default Markdown
